export default __webpack_public_path__ + "static/media/brandlive_logo.7828ac12.svg";